import { Checkbox } from '@consigli/facade';
import { useTranslation } from 'react-i18next';

interface UploadIndexFilesProps {
  uploadIndexFiles: boolean;
  setUploadIndexFiles: (value: boolean) => void;
}

export const UploadIndexFiles = ({
  uploadIndexFiles,
  setUploadIndexFiles,
}: UploadIndexFilesProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-6">
      <div className="flex">
        <Checkbox
          id="uploadIndexFiles"
          label={t('package-creation.wish-to-upload-index-files')}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setUploadIndexFiles(event.target.checked);
          }}
          value={uploadIndexFiles?.toString()}
          checked={uploadIndexFiles}
        />
      </div>
    </div>
  );
};
